import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, RotateCcw } from "lucide-react";

export function DocNumberField({ kind, label, open, branchId, value, onChange, onSuggested, maxLength = 16, testId = "doc-number" }) {
  const [info, setInfo] = useState({ number: "", locked: false });

  useEffect(() => {
    if (!open) { return; }
    api.get("/documents/next-number", { params: { kind, ...(branchId ? { branch_id: branchId } : {}) } })
      .then((r) => { setInfo(r.data); onSuggested?.(r.data.number); })
      .catch(() => setInfo({ number: "", locked: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, branchId, kind]);

  const manual = !!value && value !== info.number;
  return (
    <div>
      <Label className="text-[10px] uppercase font-mono tracking-widest flex items-center gap-1">
        {label} {info.locked && <Lock className="w-3 h-3" />}
      </Label>
      <div className="relative mt-1">
        <Input value={info.locked ? info.number : (value || info.number)} disabled={info.locked} maxLength={maxLength}
          onChange={(e) => { const v = e.target.value.toUpperCase(); onChange(v === info.number ? "" : v); }}
          className={`rounded-sm font-mono ${manual ? "border-amber-500 pr-8" : ""}`} data-testid={testId} />
        {manual && (
          <button type="button" onClick={() => onChange("")} title="Use the next number in the series"
            className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground" data-testid={`${testId}-reset`}>
            <RotateCcw className="w-3.5 h-3.5" /></button>
        )}
      </div>
      <div className="text-[10px] text-muted-foreground mt-0.5" data-testid={`${testId}-hint`}>
        {info.locked ? "Locked by admin · auto-numbered" : manual ? "Manual number · series not used" : "Next in series · type to change"}
      </div>
    </div>
  );
}

export const InvoiceNumberField = (p) => <DocNumberField kind="sales_invoice" label="Invoice No." testId="inv-number" {...p} />;
